<script>
	import { fade, blur, fly, slide, scale } from "svelte/transition";
	import { results } from "../stores.js";

	export let result;

	$: summary = $results[result];
</script>

<div class="summary" style:background-color={summary.color} transition:fade>
	<img src={`${PATH}${summary.icon}`} class="icon" />
	<div class="text">{@html summary.label}</div>
</div>

<style lang="scss">
	.summary {
		border-radius: 5px;
		padding: 8px 10px;
		display: flex;
		align-items: center;
		margin-bottom: 13px;
		transition: background-color 1s ease-in;
	}

	.icon {
		width: 37px;
		padding-right: 10px;
	}

	.text {
		font-size: 13px;
		line-height: 14px;
		font-weight: 600;
		color: white;
		letter-spacing: 0.01em;
	}

	@media (min-width: 840px) {
		.text {
			font-size: 15px;
			line-height: 14px;
		}
	}
</style>
